import React, { useState, useEffect } from "react";
// componentes
import { Row, Col, Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import ButtonSpinner from "../../../../components/Buttons/ButtonSpinner";
// redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// services
import { createSurvey } from "../../../../utils/services/superScreen";
import { getMobileAppsByEvent } from "../../../../utils/services/mobileApps";

function ModalNewSurvey(props) {
  const { isOpen, toggle } = props;
  // state de loading
  const [isLoading, setIsLoading] = useState(false);

  const [response, setResponse] = useState(false);
  const [points, setPoints] = useState(false);
  const [sendQuestion, setSendQuestion] = useState(true);
  // dados do formulário
  const [formData, setFormData] = useState({});
  const [openAnswer, setOpenAnswer] = useState(false);
  // erros do formulário
  const [formErros, setFormErros] = useState({});
  // alerta
  const [successAlert, setSuccessAlert] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState("");
  // apps
  const [mobileapps, setMobileApps] = useState([]);

  // normaliza e formata o texto digitado como resposta aberta
  function formatAnswer(e) {
    var stringFormat = e
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase();

    return stringFormat;
  }

  // valida os campos obrigatórios antes de enviar o formulário
  function verifyErrros() {
    setIsLoading(true);

    if (!formData.question) {
      setIsLoading(false);
      setFormErros({ question: "Esse campo é obrigatório" });
      return;
    }

    if (!formData.option1 && !openAnswer) {
      setIsLoading(false);
      setFormErros({ option1: "Esse campo é obrigatório" });
      return;
    }

    if (!formData.option2 && !openAnswer) {
      setIsLoading(false);
      setFormErros({ option2: "Esse campo é obrigatório" });
      return;
    }

    if (
      formData.rightAnswer &&
      (!formData.optionRightAnswer ||
        formData.optionRightAnswer === "Selecione")
    ) {
      setIsLoading(false);
      setFormErros({ optionRightAnswer: "Esse campo é obrigatório" });
      return;
    }

    if (formData.points && !formData.pointsCode) {
      setIsLoading(false);
      setFormErros({ pointsCode: "Esse campo é obrigatório" });
      return;
    }

    if (!formData.sendAnswerNow && !formData.dateToSend) {
      setIsLoading(false);
      setFormErros({ dateToSend: "Esse campo é obrigatório" });
      return;
    }
    setFormErros({});

    submitForm();
  }

  // monta o payload e cria a enquete
  function submitForm() {
    const firebaseProjectsId = mobileapps
      .map((e) => `${e?.idfirebaseproject}`)
      .join(",");

    const data = {
      transmissionId: props.idSuperScreen,
      eventId: props.idEvent,
      question: formData.question,
      option1: !openAnswer ? formData.option1 : "",
      option2: !openAnswer ? formData.option2 : "",
      option3: !openAnswer && formData.option3 ? formData.option3 : "",
      option4: !openAnswer && formData.option4 ? formData.option4 : "",
      option5: !openAnswer && formData.option5 ? formData.option5 : "",
      rightAnswer: formData.rightAnswer,
      answer: formData.rightAnswer
        ? verifyCorrectAnswer(formData.optionRightAnswer)
        : "",
      hasScore: formData.points,
      scoreCode: formData.pointsCode ? formData.pointsCode : "",
      scoreOnlyRightAnswer: formData.pointsRightAnswer
        ? formData.pointsRightAnswer
        : false,
      dateSurvey: formData.sendAnswerNow
        ? new Date(Date.now())
        : new Date(formData.dateToSend),
      scheduled: !sendQuestion,
      tipo: openAnswer ? "Aberta" : "Fechada",
      firebaseProject: firebaseProjectsId,
    };
    createSurvey(data, props.state.global_user_data.data.token)
      .then((res) => {
        setIsLoading(false);
        if (res.message === "created") {
          props.getAllSurvey();
          setSuccessAlert(true);
        } else {
          setSubmitErrorMessage("Erro ao criar enquete.");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Erro ao criar enquete:", error);
        setSubmitErrorMessage("Erro ao criar enquete.");
      });
  }

  // retorna o texto da opção escolhida como resposta certa
  function verifyCorrectAnswer(e) {
    var answer = Number(e);
    if (answer === 1) {
      return formData.option1;
    } else if (answer === 2) {
      return formData.option2;
    } else if (answer === 3) {
      return formData.option3;
    } else if (answer === 4) {
      return formData.option4;
    } else if (answer === 5) {
      return formData.option5;
    } else return e;
  }

  // busca os apps mobile do evento para montar a lista de projetos firebase
  async function getMobileAppEvent() {
    await getMobileAppsByEvent({
      jwt: props.state.global_user_data.data.token,
      eventId: props.idEvent,
    })
      .then((response) => {
        setMobileApps(response.findOneMobileAppData);
      })
      .catch((error) => {
        console.error("Erro ao buscar apps mobile:", error);
        toast.error("Erro ao buscar apps mobile.");
      });
  }

  useEffect(() => {
    setFormData({
      rightAnswer: false,
      points: false,
      pointsRightAnswer: false,
      sendAnswerNow: true,
    });

    getMobileAppEvent();
  }, []);

  useEffect(() => {
    setFormData((state) => {
      return {
        ...state,
        optionRightAnswer: null,
      };
    });
  }, [openAnswer]);

  return (
    <Modal isOpen={isOpen} centered autoFocus size="lg">
      {successAlert ? (
        <SweetAlert
          success
          title="Criado"
          onConfirm={() => {
            toggle();
            setSuccessAlert(false);
          }}
        >
          Enquete criada com sucesso
        </SweetAlert>
      ) : null}
      {submitErrorMessage && (
        <SweetAlert
          danger
          title="Erro"
          onConfirm={() => setSubmitErrorMessage("")}
        >
          {submitErrorMessage}
        </SweetAlert>
      )}
      <ModalHeader toggle={toggle}>Nova Enquete</ModalHeader>
      <ModalBody>
        <Row>
          <Col md={12}>
            <label className="form-label">Pergunta *</label>
            <input
              className="form-control"
              type="text"
              onChange={(e) =>
                setFormData((state) => {
                  return {
                    ...state,
                    question: e.target.value,
                  };
                })
              }
            />
            {formErros.question && (
              <span className="text-danger">{formErros.question}</span>
            )}
          </Col>
        </Row>

        <Row className="mt-3">
          <Col md={4}>
            <label className="form-label">Tipo de Enquete *</label>
            <div>
              <input
                type="radio"
                name="openAnswer"
                value="link"
                style={{ marginRight: 5 }}
                id="openAnswerOption1"
                defaultChecked
                onChange={() => {
                  setOpenAnswer(false);
                }}
              />
              <label htmlFor="openAnswerOption1" className="form-label">
                Fechada
              </label>
            </div>
            <div>
              <input
                type="radio"
                name="openAnswer"
                value="link"
                style={{ marginRight: 5 }}
                id="openAnswerOption2"
                onChange={() => {
                  setOpenAnswer(true);
                }}
              />
              <label htmlFor="openAnswerOption2" className="form-label">
                Aberta
              </label>
            </div>
          </Col>
        </Row>

        {!openAnswer && (
          <>
            <Row className="mt-3">
              <Col md={4}>
                <label className="form-label">Opção 1 *</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) =>
                    setFormData((state) => {
                      return {
                        ...state,
                        option1: e.target.value,
                      };
                    })
                  }
                />
                {formErros.option1 && (
                  <span className="text-danger">{formErros.option1}</span>
                )}
              </Col>

              <Col md={4}>
                <label className="form-label">Opção 2 *</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) =>
                    setFormData((state) => {
                      return {
                        ...state,
                        option2: e.target.value,
                      };
                    })
                  }
                />
                {formErros.option2 && (
                  <span className="text-danger">{formErros.option2}</span>
                )}
              </Col>

              <Col md={4}>
                <label className="form-label">Opção 3</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) =>
                    setFormData((state) => {
                      return {
                        ...state,
                        option3: e.target.value,
                      };
                    })
                  }
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={6}>
                <label className="form-label">Opção 4</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) =>
                    setFormData((state) => {
                      return {
                        ...state,
                        option4: e.target.value,
                      };
                    })
                  }
                />
              </Col>

              <Col md={6}>
                <label className="form-label">Opção 5</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) =>
                    setFormData((state) => {
                      return {
                        ...state,
                        option5: e.target.value,
                      };
                    })
                  }
                />
              </Col>
            </Row>
          </>
        )}

        <Row className="mt-3">
          <Col md={4}>
            <label className="form-label">Resposta correta? *</label>
            <div>
              <input
                type="radio"
                name="response"
                value="link"
                style={{ marginRight: 5 }}
                id="responseOption1"
                defaultChecked
                onChange={() => {
                  setResponse(false);
                  setFormData((state) => {
                    return {
                      ...state,
                      rightAnswer: false,
                    };
                  });
                }}
              />
              <label htmlFor="responseOption1" className="form-label">
                Não
              </label>
            </div>
            <div>
              <input
                type="radio"
                name="response"
                value="link"
                style={{ marginRight: 5 }}
                id="responseOption2"
                onChange={() => {
                  setResponse(true);
                  setFormData((state) => {
                    return {
                      ...state,
                      rightAnswer: true,
                    };
                  });
                }}
              />
              <label htmlFor="responseOption2" className="form-label">
                Sim
              </label>
            </div>
          </Col>

          <Col md={4}>
            <label className="form-label">Possui pontuação? *</label>
            <div>
              <input
                type="radio"
                name="points"
                value="link"
                style={{ marginRight: 5 }}
                id="pointsOption1"
                defaultChecked
                onChange={() => {
                  setPoints(false);
                  setFormData((state) => {
                    return {
                      ...state,
                      points: false,
                    };
                  });
                }}
              />
              <label htmlFor="pointsOption1" className="form-label">
                Não
              </label>
            </div>
            <div>
              <input
                type="radio"
                name="points"
                value="link"
                style={{ marginRight: 5 }}
                id="pointsOption2"
                onChange={() => {
                  setPoints(true);
                  setFormData((state) => {
                    return {
                      ...state,
                      points: true,
                    };
                  });
                }}
              />
              <label htmlFor="pointsOption2" className="form-label">
                Sim
              </label>
            </div>
          </Col>

          {points && response && (
            <Col md={4}>
              <label className="form-label">
                Pontuar somente a resposta correta *
              </label>
              <div>
                <input
                  type="radio"
                  name="responseCorrect"
                  style={{ marginRight: 5 }}
                  id="responseCorrectOption1"
                  defaultChecked
                  onChange={() => {
                    setFormData((state) => {
                      return {
                        ...state,
                        pointsRightAnswer: false,
                      };
                    });
                  }}
                />
                <label htmlFor="responseCorrectOption1" className="form-label">
                  Não
                </label>
              </div>

              <div>
                <input
                  type="radio"
                  name="responseCorrect"
                  style={{ marginRight: 5 }}
                  id="responseCorrectOption2"
                  onChange={() => {
                    setFormData((state) => {
                      return {
                        ...state,
                        pointsRightAnswer: true,
                      };
                    });
                  }}
                />
                <label htmlFor="responseCorrectOption2" className="form-label">
                  Sim
                </label>
              </div>
            </Col>
          )}
        </Row>

        <Row className="mt-3">
          {response && (
            <Col md={4}>
              <label className="form-label">Resposta *</label>
              {openAnswer ? (
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => {
                    setFormData((state) => {
                      return {
                        ...state,
                        optionRightAnswer: formatAnswer(e.target.value),
                      };
                    });
                  }}
                />
              ) : (
                <select
                  className="form-control"
                  onChange={(e) => {
                    setFormData((state) => {
                      return {
                        ...state,
                        optionRightAnswer: e.target.value,
                      };
                    });
                  }}
                >
                  <option>Selecione</option>
                  <option value={1}>Opção 1</option>
                  <option value={2}>Opção 2</option>
                  {formData.option3 && <option value={3}>Opção 3</option>}
                  {formData.option4 && <option value={4}>Opção 4</option>}
                  {formData.option5 && <option value={5}>Opção 5</option>}
                </select>
              )}
              {formErros.optionRightAnswer && (
                <span className="text-danger">
                  {formErros.optionRightAnswer}
                </span>
              )}
            </Col>
          )}

          {points && (
            <Col md={4}>
              <label className="form-label">Código da pontuação *</label>
              <input
                className="form-control"
                type="text"
                onChange={(e) => {
                  setFormData((state) => {
                    return {
                      ...state,
                      pointsCode: e.target.value,
                    };
                  });
                }}
              />
              {formErros.pointsCode && (
                <span className="text-danger">{formErros.pointsCode}</span>
              )}
            </Col>
          )}
        </Row>

        <Row className="mt-3">
          <Col md={4}>
            <label className="form-label">Enviar pergunta agora *</label>
            <div>
              <input
                type="radio"
                name="sendQuestion"
                style={{ marginRight: 5 }}
                id="sendQuestionOption2"
                defaultChecked
                onChange={(e) => {
                  setSendQuestion(true);
                  setFormData((state) => {
                    return {
                      ...state,
                      sendAnswerNow: true,
                    };
                  });
                }}
              />
              <label htmlFor="sendQuestionOption2" className="form-label">
                Sim
              </label>
            </div>
            <div>
              <input
                type="radio"
                name="sendQuestion"
                style={{ marginRight: 5 }}
                id="sendQuestionOption1"
                onChange={(e) => {
                  setSendQuestion(false);
                  setFormData((state) => {
                    return {
                      ...state,
                      sendAnswerNow: false,
                    };
                  });
                }}
              />
              <label htmlFor="sendQuestionOption1" className="form-label">
                Não
              </label>
            </div>
          </Col>

          {!sendQuestion && (
            <Col md={4}>
              <label className="form-label">Agendar para o dia *</label>
              <input
                className="form-control"
                type="datetime-local"
                onChange={(e) => {
                  setFormData((state) => {
                    return {
                      ...state,
                      dateToSend: e.target.value,
                    };
                  });
                }}
              />
              {formErros.dateToSend && (
                <span className="text-danger">{formErros.dateToSend}</span>
              )}
            </Col>
          )}
        </Row>

        <Row
          style={{
            width: "100%",
            margin: "auto",
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1rem",
          }}
        >
          <Button
            color="danger"
            style={{ width: 80, marginRight: 10 }}
            onClick={() => toggle()}
          >
            Fechar
          </Button>

          <ButtonSpinner
            isLoading={isLoading}
            title={"Salvar"}
            onClick={verifyErrros}
          />
        </Row>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(ModalNewSurvey);
